import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ContentReadOnly({ content }) {
    if (!content) return /*#__PURE__*/ _jsx("p", {
        children: "No content available."
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Narrative:"
                    }),
                    " ",
                    content.narrative || 'Not recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Outcomes:"
                    }),
                    " ",
                    content.outcomes || 'Not recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Scope examples:"
                    }),
                    " ",
                    content.scopeExamples.join('; ') || 'Not recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Limitations:"
                    }),
                    " ",
                    content.limitations || 'Not recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Sources:"
                    }),
                    " ",
                    content.sources.join('; ') || 'Not recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Manual fit:"
                    }),
                    " ",
                    content.fitAssessment || 'Not recorded'
                ]
            }),
            content.metrics.map((metric, index)=>/*#__PURE__*/ _jsxs("p", {
                    children: [
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                metric.measuredThing,
                                ":"
                            ]
                        }),
                        " ",
                        metric.value || 'Unknown',
                        ' ',
                        metric.unit || '(unit unknown)',
                        "; period ",
                        metric.period || 'unknown',
                        "; baseline",
                        ' ',
                        metric.baseline || 'unknown',
                        "; source ",
                        metric.source || 'unknown',
                        "; reuse",
                        ' ',
                        metric.reuseStatus
                    ]
                }, index)),
            content.comparisons.map((comparison, index)=>/*#__PURE__*/ _jsxs("p", {
                    children: [
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                comparison.dimension,
                                " — ",
                                comparison.assessment.replace(/_/g, ' '),
                                ":"
                            ]
                        }),
                        ' ',
                        "Pursuit: ",
                        comparison.pursuitContext || 'Unknown',
                        "; reference:",
                        ' ',
                        comparison.referenceContext || 'Unknown',
                        "; source: ",
                        comparison.source || 'Unknown',
                        ' ; ',
                        "missing: ",
                        comparison.missingEvidence || 'None recorded'
                    ]
                }, index)),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Missing evidence:"
                    }),
                    " ",
                    content.missingEvidence.join('; ') || 'None recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "Targeted follow-up:"
                    }),
                    " ",
                    content.followUp || 'Not recorded'
                ]
            })
        ]
    });
}
